module.exports = __webpack_public_path__ + "static/media/soup1.50d5174f.png";